import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Stack,
  CssBaseline,
} from "@mui/material";
import AppTheme from "../shared-theme/AppTheme";
import axios from "axios";
import { API_BASE } from "../lib/api";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function VerifyOTPPage() {
  const q = useQuery();
  const navigate = useNavigate();
  const emailFromQuery = q.get("email") || "";
  const [email, setEmail] = React.useState(emailFromQuery);
  const [code, setCode] = React.useState("");
  const [error, setError] = React.useState("");
  const [info, setInfo] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const submit = async () => {
    setError("");
    setInfo("");
    if (!email || !code) {
      setError("Email and code are required.");
      return;
    }
    try {
      setLoading(true);
      await axios.post(`${API_BASE}/verify-otp`, { email, code });
      setInfo("Email verified successfully. You can now sign in.");
      setTimeout(() => navigate("/signin"), 1000);
    } catch (e) {
      setError(e?.response?.data?.error || "Verification failed.");
    } finally {
      setLoading(false);
    }
  };

  const resend = async () => {
    setError("");
    setInfo("");
    try {
      await axios.post(`${API_BASE}/resend-otp`, { email });
      setInfo("A new code has been sent to your email.");
    } catch (e) {
      setError(e?.response?.data?.error || "Could not resend code.");
    }
  };

  return (
    <AppTheme>
      <CssBaseline />
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Box sx={{ textAlign: "center" }}>
          <img
            src="/images/seedsLogo.png"
            alt="SEEDS"
            style={{ height: 72, marginBottom: 16 }}
          />
          <Typography variant="h4" gutterBottom>
            Verify your email
          </Typography>
          <Typography sx={{ mb: 3 }}>
            Enter the 6-digit code we sent to your email.
          </Typography>

          <Stack spacing={2}>
            <TextField
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
            />
            <TextField
              label="6-digit code"
              value={code}
              onChange={(e) =>
                setCode(e.target.value.replace(/\D/g, "").slice(0, 6))
              }
              fullWidth
            />
            <Button variant="contained" onClick={submit} disabled={loading}>
              Verify
            </Button>
            <Button variant="text" onClick={resend} disabled={!email}>
              Resend code
            </Button>
            {error && <Alert severity="error">{error}</Alert>}
            {info && <Alert severity="success">{info}</Alert>}
          </Stack>
        </Box>
      </Container>
    </AppTheme>
  );
}
